import { Icon, InputWithIcon, SelectMenu } from '@livable/saas-react-components';
import { TextField, MenuItem } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import RangeDatePicker from 'src/components/general/RangeDatePicker';
import useStyles from './styles';
export default function SearchBar() {
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.searchBar
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.searchField
  }, /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "search"
    })
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "charges-search",
    label: t('general.search'),
    variant: "outlined",
    fullWidth: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.filterSelector
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "who-selector",
    label: t('general.transaction'),
    labelId: "who-selector-label"
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: "all"
  }, t('general.all_transactions')))), /*#__PURE__*/React.createElement("div", {
    className: classes.filterSelector
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "changes-type-selector",
    label: t('general.subtypes'),
    labelId: "changes-type-selector-label"
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: "all"
  }, t('general.all_types')))), /*#__PURE__*/React.createElement("div", {
    className: classes.chargesRangeDatePicker
  }, /*#__PURE__*/React.createElement(RangeDatePicker, null)));
}